import React from "react";
import { ErrorCode } from "react-dropzone";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { DropzoneContentIcon } from "./DropzoneContentIcon.js";
const localized = defineMessages({
  dropzoneContentFailedTooLargeMessage: {
    id: "FDZC_tooLargeMessage",
    defaultMessage: "File {filename} is too large"
  },
  dropzoneContentFailedInvalidTypeMessage: {
    id: "FDZC_invalidTypeMessage",
    defaultMessage: "File {filename} isn't in the correct format"
  },
  dropzoneContentFailedTooSmallMessage: {
    id: "FDZC_tooSmallMessage",
    defaultMessage: "File {filename} is too small"
  },
  dropzoneContentFailedTooManyFilesMessage: {
    id: "FDZC_tooSmallMessage",
    defaultMessage: "You can drop only one file here"
  }
});
const DropzoneContentMessageFailed = ({ fileRejection }) => {
  const errorCodeToFailedMessageMapper = {
    [ErrorCode.FileTooLarge]: localized.dropzoneContentFailedTooLargeMessage,
    [ErrorCode.FileInvalidType]: localized.dropzoneContentFailedInvalidTypeMessage,
    [ErrorCode.FileTooSmall]: localized.dropzoneContentFailedTooSmallMessage,
    [ErrorCode.TooManyFiles]: localized.dropzoneContentFailedTooManyFilesMessage
  };
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(
    LocalizedText,
    {
      label: errorCodeToFailedMessageMapper[fileRejection.errors[0].code],
      labelParams: {
        filename: /* @__PURE__ */ React.createElement("b", null, fileRejection?.file?.name ?? "")
      }
    }
  ));
};
function DropzoneContentFailed({ rejectFile }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DropzoneContentIcon, { type: "failed" }), rejectFile ? /* @__PURE__ */ React.createElement(DropzoneContentMessageFailed, { fileRejection: rejectFile }) : null);
}
export {
  DropzoneContentFailed
};
//# sourceMappingURL=DropzoneContentFailed.js.map
